<template>
  <main class="d-flex flex-row flex-wrap justify-content-between">
    <div class="col-12 d-flex justify-content-end px-0 py-1">
      <!-- <button @click="fetchPOSConfigsDictionaries">test</button> -->
      <i
        class="text-info fa fa-question-circle"
        role="btn"
        style="font-size: 25px; cursor: pointer"
        aria-hidden="true"
        @click="showInfoPopUp"
      ></i>
    </div>
    <div class="d-none d-md-block col-md-5">
      <card v-for="(branch, index) in branches" :key="index">
        <div class="d-flex flex-row col">
          <i
            class="fa fa-map-marker fa-2x mr-2 text-danger"
            aria-hidden="true"
          ></i>
          <h5 class="text-wrap">{{ branch.nombreSucursal.toUpperCase() }}</h5>
          <p class="mr-0 ml-auto">{{ index + 1 }}</p>
        </div>
        <div class="col-12 d-flex flex-row justify-content-around">
          <button
            @click="handleBranchEditSelect(branch._id, 'general')"
            class="btn btn-info w-auto"
            :class="accountType === 'SOPORTE' ? 'btn-sm' : ''"
          >
            general
          </button>
          <button
            @click="handleBranchEditSelect(branch._id, 'ticket')"
            class="btn btn-info w-auto"
            :class="accountType === 'SOPORTE' ? 'btn-sm' : ''"
          >
            TICKETS
          </button>
          <button
            class="btn btn-info w-auto btn-sm"
            @click="handleBranchEditSelect(branch._id, 'integraciones')"
            v-if="accountType === 'SOPORTE'"
          >
            integraciones
          </button>
        </div>
      </card>
    </div>
    <collapse :multiple-active="false" class="d-md-none col-12 p-0">
      <collapse-item
        v-for="(branch, index) in branches"
        :name="`${index + 1}`"
        class="p-0"
        @clicked="handleCollapseItemChange()"
        :key="index"
      >
        <template slot="title">
          <span class="lead w-100"
            >{{ index + 1 }} {{ branch.nombreSucursal }}</span
          ></template
        >
        <card class="w-100 mb-4">
          <div class="d-flex flex-row col">
            <h5 class="text-wrap">
              Configuraciones
              <i class="fa fa-cog text-muted" aria-hidden="true"></i>
            </h5>
          </div>
          <div class="col-12 d-flex flex-row justify-content-around">
            <button
              @click="handleBranchEditSelect(branch._id, 'general')"
              class="btn btn-info w-auto"
            >
              general
            </button>
            <button
              @click="handleBranchEditSelect(branch._id, 'ticket')"
              class="btn btn-info w-auto"
            >
              TICKETS
            </button>
            <button class="btn btn-info w-auto" disabled>cajas</button>
          </div>
        </card>
        <card v-if="show === 'general'" class="w-100 px-0">
          <p class="lead text-center">GENERAL</p>
          <h6 class="mb-1 mt-4">Cierres de caja</h6>
          <hr class="mt-0" />
          <div class="d-flex flex-row my-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-envelope-o mr-1" aria-hidden="true"></i>
              <p class="mb-0">Habilitar envío</p>
            </div>
            <div>
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model="activeBranchConfig.GENERAL.PV_V_HEEPOS"
                :disabled="!editGeneral"
              ></p-switch>
            </div>
          </div>
          <div class="d-flex flex-row mb-1 mb-0 align-items-end">
            <div
              class="col-4 d-flex flex-row text-secondary"
              :class="correoCierresCaja.length > 1 ? 'mt-1 mb-auto' : ''"
            >
              <i class="fa fa-envelope-o mr-1" aria-hidden="true"></i>
              <p class="mb-0">Correo envio</p>
            </div>
            <div>
              <div
                v-for="(correo, index) in correoCierresCaja"
                class="d-flex flex-row"
                :class="correoCierresCaja.length > 1 ? 'mb-2' : ''"
                :key="index"
              >
                <input
                  type="email"
                  class="form-control mr-2"
                  v-model.trim="correoCierresCaja[index]"
                  :disabled="!editGeneral"
                />
                <button
                  class="btn btn-success my-0 w-auto py-1 px-2"
                  @click="addCorreoCierresCaja"
                  :disabled="!editGeneral"
                >
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
                <button
                  class="btn btn-danger my-0 w-auto py-1 px-2"
                  @click="correoCierresCaja.splice(index, 1)"
                  :disabled="correoCierresCaja.length === 1 || !editGeneral"
                >
                  <i class="fa fa-minus" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="d-flex flex-row my-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-file-excel-o mr-1" aria-hidden="true"></i>
              <p class="my-auto">Adjuntar Excel</p>
            </div>
            <div>
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model="activeBranchConfig.GENERAL.PV_V_EARVD"
                :disabled="!editGeneral"
              ></p-switch>
            </div>
          </div>
          <div class="d-flex flex-row my-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-envelope-o mr-1" aria-hidden="true"></i>
              <p class="mb-0">Enviar Resumen</p>
            </div>
            <div>
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model="activeBranchConfig.GENERAL.PV_V_EMRCC"
                :disabled="!editGeneral"
              ></p-switch>
            </div>
          </div>
          <div class="d-flex flex-row my-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-envelope-o mr-1" aria-hidden="true"></i>
              <p class="mb-0">Visualizar Montos</p>
            </div>
            <div>
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model="activeBranchConfig.GENERAL.PV_MMRC"
                :disabled="!editGeneral"
              ></p-switch>
            </div>
          </div>
          <div class="d-flex flex-row mb-1 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-print mr-1" aria-hidden="true"></i>
              <p class="mb-0">Imprimir Resumen</p>
            </div>
            <div>
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model="activeBranchConfig.GENERAL.ALM_USAR_TKT_RESCCAJA"
                :disabled="!editGeneral"
              ></p-switch>
            </div>
          </div>

          <h6 class="mb-1 mt-4">Ventas</h6>
          <hr class="mt-0" />
          <div class="d-flex flex-row mb-1 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-envelope-o mr-1 mt-1" aria-hidden="true"></i>
              <p class="mb-0">Habilitar descuento/recargo</p>
            </div>
            <div class="d-flex flex-row col-8">
              <div class="m-auto">
                <p-switch
                  type="success"
                  class="mx-auto my-auto"
                  size="small"
                  on-text=""
                  off-text=""
                  v-model="activeBranchConfig.GENERAL.DSC_PV"
                  :disabled="!editGeneral"
                ></p-switch>
              </div>
              <p-checkbox
                class="col my-2"
                v-model="activeBranchConfig.GENERAL.PV_DSC"
                label="1"
                :disabled="!editGeneral || !activeBranchConfig.GENERAL.DSC_PV"
                >Desc.</p-checkbox
              >
              <p-checkbox
                class="col my-2"
                v-model="activeBranchConfig.GENERAL.PV_REC"
                label="2"
                :disabled="!editGeneral || !activeBranchConfig.GENERAL.DSC_PV"
                >Recargo</p-checkbox
              >
            </div>
          </div>
          <small v-if="errorDesREC" class="text-end col-12 text-danger">{{
            errorDesREC
          }}</small>
          <div class="d-flex flex-row mb-1 mb-0 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-building-o mr-1" aria-hidden="true"></i>
              <p class="mb-0">Porcentaje Defecto</p>
            </div>
            <input
              type="number"
              class="form-control col-2"
              :disabled="!editGeneral || !activeBranchConfig.GENERAL.DSC_PV"
              v-model.number="activeBranchConfig.GENERAL.DSC_PV_PORC_DEF"
            />
          </div>
          <div class="d-flex flex-row mb-1 mb-0 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-building-o mr-1" aria-hidden="true"></i>
              <p class="mb-0">Porcentaje Max.</p>
            </div>
            <input
              type="number"
              class="form-control col-2"
              :disabled="!editGeneral || !activeBranchConfig.GENERAL.DSC_PV"
              v-model.number="activeBranchConfig.GENERAL.DSC_PV_MAX_PERM"
            />
          </div>
          <div class="d-flex flex-row my-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-money mr-1" aria-hidden="true"></i>
              <p class="mb-0">Sólo efectivo</p>
            </div>
            <div>
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model="activeBranchConfig.GENERAL.PV_V_MPEFEC"
                :disabled="!editGeneral"
              ></p-switch>
            </div>
          </div>
          <div class="d-flex flex-row my-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-money mr-1" aria-hidden="true"></i>
              <p class="mb-0">Ventas Manuales</p>
            </div>
            <div>
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model="activeBranchConfig.GENERAL.NO_OPER"
                :disabled="!editGeneral"
              ></p-switch>
            </div>
          </div>
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i
                class="fa pt-1 fa-balance-scale mb-0 mr-1"
                aria-hidden="true"
              ></i>
              <p class="mb-0">Impuesto/IVA</p>
            </div>
            <input
              type="number"
              class="form-control col-2"
              :disabled="!editGeneral"
              v-model.number="activeBranchConfig.GENERAL.IMP"
            />
          </div>
          <template v-if="accountType === 'SOPORTE'">
            <h6 class="mb-1 mt-4">Conexión SQL</h6>
            <hr class="mt-0" />
            <div class="d-flex flex-row mb-2 align-items-end">
              <div class="col-4 d-flex flex-row text-secondary">
                <i class="fa pt-1 fa-desktop mr-1" aria-hidden="true"></i>
                <p class="mb-0">Data Source</p>
              </div>
              <input
                type="text"
                class="form-control"
                :disabled="!editGeneral"
                v-model.trim="activeBranchConfig.BD.DTASOURCE"
              />
            </div>
            <div class="d-flex flex-row mb-2 align-items-end">
              <div class="col-4 d-flex flex-row text-secondary">
                <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
                <p class="mb-0">Network Library</p>
              </div>
              <input
                type="text"
                class="form-control"
                placeholder="Ej: [IP]/SQL_MIR1"
                :disabled="!editGeneral"
                v-model.trim="activeBranchConfig.BD.NETWORKLIBRARY"
              />
            </div>
            <div class="d-flex flex-row mb-2 align-items-end">
              <div class="col-4 d-flex flex-row text-secondary">
                <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
                <p class="mb-0">Catalog</p>
              </div>
              <input
                type="text"
                class="form-control"
                :disabled="!editGeneral"
                v-model.trim="activeBranchConfig.BD.CATALOG"
              />
            </div>
            <div class="d-flex flex-row mb-2 align-items-end">
              <div class="col-4 d-flex flex-row text-secondary">
                <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
                <p class="mb-0">User</p>
              </div>
              <input
                type="text"
                class="form-control"
                :disabled="!editGeneral"
                v-model.trim="activeBranchConfig.BD.USER"
              />
            </div>
            <div class="d-flex flex-row mb-2 align-items-end">
              <div class="col-4 d-flex flex-row text-secondary">
                <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
                <p class="mb-0">Password</p>
              </div>
              <input
                type="password"
                class="form-control"
                placeholder="***************"
                :disabled="!editGeneral"
                v-model="activeBranchConfig.BD.PASSWORD"
              />
            </div>
            <div class="d-flex flex-row mb-2 align-items-end">
              <div class="col-4 d-flex flex-row text-secondary">
                <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
                <p class="mb-0">Timeout</p>
              </div>
              <input
                type="number"
                class="form-control col-2"
                :disabled="!editGeneral"
                v-model="activeBranchConfig.BD.TIMEOUT"
              />
            </div>
          </template>
          <h6 class="mb-1 mt-4">BIOMETRIA (huellas)</h6>
          <hr class="mt-0" />
          <el-tooltip :open-delay="200" placement="top">
            <template #content>
              Si está deshabilitado no será posible cambiar la huella de un
              socio luego de ser enrolado
            </template>
            <div class="d-flex flex-row my-2 align-items-end">
              <div class="col-4 d-flex flex-row text-secondary">
                <i
                  class="nc-icon nc-touch-id mr-1"
                  aria-hidden="true"
                  style="font-size: 20px"
                ></i>
                <p class="mb-0">Permitir cambio</p>
              </div>
              <div>
                <p-switch
                  type="success"
                  class="mx-auto my-auto"
                  size="small"
                  on-text=""
                  off-text=""
                  v-model="activeBranchConfig.GENERAL.FS_BIO_ACT"
                  :disabled="!editGeneral"
                ></p-switch>
              </div></div
          ></el-tooltip>
          <el-tooltip :open-delay="200" placement="top">
            <template #content>
              Cantidad maxima de huellas enroladas por socio
            </template>
            <div class="d-flex flex-row mb-2 align-items-end">
              <div class="col-4 d-flex flex-row text-secondary">
                <i
                  class="nc-icon nc-touch-id mb-0 mr-1"
                  aria-hidden="true"
                  style="font-size: 20px"
                ></i>
                <p class="mb-0">Cantidad</p>
              </div>
              <input
                type="number"
                class="form-control col-2"
                min="1"
                max="10"
                :disabled="!editGeneral"
                v-model.number="activeBranchConfig.GENERAL.FS_BIO_NRO_MAX"
              /></div
          ></el-tooltip>
          <h6 class="mb-1 mt-4">MISCELáNEOS</h6>
          <hr class="mt-0" />
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
              <p class="mb-0">Nombre Sistema</p>
            </div>
            <input
              type="text"
              class="form-control"
              :disabled="!editGeneral"
              v-model.trim="activeBranchConfig.GENERAL.SISTEM_NAME"
            />
          </div>
          <div class="d-flex flex-row my-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-desktop mr-1" aria-hidden="true"></i>
              <p class="mb-0">Fullscreen</p>
            </div>
            <div>
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model="activeBranchConfig.GENERAL.PV_V_FS"
                :disabled="!editGeneral"
              ></p-switch>
            </div>
          </div>

          <div class="d-flex flex-row my-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-comments-o mr-1" aria-hidden="true"></i>
              <p class="mb-0">Mensajes Sistema</p>
            </div>
            <div>
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model="activeBranchConfig.GENERAL.MSJS"
                :disabled="!editGeneral"
              ></p-switch>
            </div>
          </div>
          <h6 class="mb-1 mt-4">Inventario</h6>
          <hr class="mt-0" />
          <div class="d-flex flex-row my-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-comments-o mr-1" aria-hidden="true"></i>
              <p class="mb-0">Ver Minituras</p>
            </div>
            <div>
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model="activeBranchConfig.GENERAL.UT_IMG_PV"
                :disabled="!editGeneral"
              ></p-switch>
            </div>
          </div>
          <small
            class="text-danger"
            v-for="(error, i) in errorStringsGeneral"
            :key="i"
          >
            {{ error }}</small
          >
          <div class="col-12 d-flex justify-content-center">
            <button
              v-if="!editGeneral"
              class="btn btn-info mx-auto"
              @click="handleEditEnable('editGeneral')"
            >
              editar
            </button>
            <template v-else>
              <button
                class="btn btn-success mr-4"
                @click="handleEditSave('editGeneral')"
                :disabled="errorStringsGeneral.length > 0"
              >
                guardar
              </button>
              <button
                class="btn btn-danger"
                @click="handleEditCancel('editGeneral')"
              >
                CANCELAR
              </button>
            </template>
          </div>
        </card>
        <!-- CONFIGURACION TICKET DE VENTA -->
        <card v-if="show === 'ticket'" class="col-md-7 px-0">
          <p class="lead text-center">CONFIGURACIÓN DE TICKETS</p>
          <h6 class="mb-1 mt-4">Empresa</h6>
          <hr class="mt-0" />
          <div class="d-flex flex-row mb-1 mb-0 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-building-o mr-1" aria-hidden="true"></i>
              <p class="mb-0">Razón Social</p>
            </div>
            <input
              type="text"
              class="form-control"
              v-model.trim="activeBranchConfig.GENERAL.TKT_RS"
              :disabled="!editTicket"
            />
          </div>
          <div class="d-flex flex-row mb-1 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-building-o mr-1" aria-hidden="true"></i>
              <p class="mb-0">Giro</p>
            </div>
            <input
              type="text"
              class="col-8 border-bottom form-control"
              v-model.trim="activeBranchConfig.GENERAL.TKT_GRO"
              :disabled="!editTicket"
            />
          </div>
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-building-o mr-1" aria-hidden="true"></i>
              <p class="mb-0">Rut</p>
            </div>
            <input
              type="text"
              class="form-control text-uppercase"
              v-model.trim="activeBranchConfig.GENERAL.TKT_RUT"
              v-mask="'##.###.###-N'"
              placeholder="Ej: 12.345.678-9"
              :disabled="!editTicket"
            />
          </div>
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-building-o mr-1" aria-hidden="true"></i>
              <p class="mb-0">S.I.I.</p>
            </div>
            <input
              type="text"
              class="form-control"
              placeholder="Ej: S.I.I. [CIUDAD]"
              v-model.trim="activeBranchConfig.GENERAL.TKT_SII"
              :disabled="!editTicket"
            />
          </div>
          <h6 class="mb-1 mt-4">Ubicación y contacto</h6>
          <hr class="mt-0" />
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa pt-1 fa-map-marker mr-1" aria-hidden="true"></i>
              <p class="mb-0">Dirección</p>
            </div>
            <input
              type="text"
              class="form-control"
              :disabled="!editTicket"
              v-model.trim="activeBranchConfig.GENERAL.TKT_DIR"
            />
          </div>
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa pt-1 fa-phone mb-0 mr-1" aria-hidden="true"></i>
              <p class="mb-0">Teléfono</p>
            </div>
            <input
              type="text"
              class="form-control"
              :disabled="!editTicket"
              v-model.trim="activeBranchConfig.GENERAL.TKT_FON"
            />
          </div>
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
              <p class="mb-0">Sitio || RR.SS.</p>
            </div>
            <input
              type="text"
              class="form-control"
              :disabled="!editTicket"
              v-model.trim="activeBranchConfig.GENERAL.TKT_PW"
            />
          </div>
          <h6 class="mb-1 mt-4">Horarios</h6>
          <hr class="mt-0" />
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa pt-1 fa-clock-o mb-0 mr-1" aria-hidden="true"></i>
              <p class="mb-0">Lunes a Viernes</p>
            </div>
            <div class="col-8 d-flex flex-row">
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model="switchMonToFri"
                :disabled="!editTicket"
              ></p-switch>
              <div v-if="switchMonToFri" class="col-10 d-flex flex-row">
                <input
                  v-mask="'##:##'"
                  placeholder="HH:MM"
                  v-model="operatingHoursMonToFri[0]"
                  class="form-control col-5"
                  :disabled="!editTicket"
                />
                <p class="col-2 m-auto">a</p>
                <input
                  v-mask="'##:##'"
                  placeholder="HH:MM"
                  v-model="operatingHoursMonToFri[2]"
                  class="form-control col-5"
                  :disabled="!editTicket"
                />
              </div>
              <p v-else class="col-10 text-center m-auto">CERRADO</p>
            </div>
          </div>
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa pt-1 fa-clock-o mb-0 mr-1" aria-hidden="true"></i>
              <p class="mb-0">Sabado</p>
            </div>
            <div class="col-8 d-flex flex-row">
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model="switchSaturday"
                :disabled="!editTicket"
              ></p-switch>
              <div v-if="switchSaturday" class="col-10 d-flex flex-row">
                <input
                  v-mask="'##:##'"
                  placeholder="HH:MM"
                  v-model="operatingHoursSaturday[0]"
                  class="form-control col-5"
                  :disabled="!editTicket"
                />
                <p class="col-2 m-auto">a</p>
                <input
                  v-mask="'##:##'"
                  placeholder="HH:MM"
                  v-model="operatingHoursSaturday[2]"
                  class="form-control col-5"
                  :disabled="!editTicket"
                />
              </div>
              <p v-else class="col-10 text-center m-auto">CERRADO</p>
            </div>
          </div>
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa pt-1 fa-clock-o mb-0 mr-1" aria-hidden="true"></i>
              <p class="mb-0">Domingo</p>
            </div>
            <div class="col-8 d-flex flex-row">
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model="switchSunday"
                :disabled="!editTicket"
              ></p-switch>
              <div v-if="switchSunday" class="col-10 d-flex flex-row">
                <input
                  v-mask="'##:##'"
                  placeholder="HH:MM"
                  v-model="operatingHoursSunday[0]"
                  class="form-control col-5"
                  :disabled="!editTicket"
                />
                <p class="col-2 m-auto">a</p>
                <input
                  v-mask="'##:##'"
                  placeholder="HH:MM"
                  v-model="operatingHoursSunday[2]"
                  class="form-control col-5"
                  :disabled="!editTicket"
                />
              </div>
              <p v-else class="col-10 text-center m-auto">CERRADO</p>
            </div>
          </div>
          <h6 class="mb-1 mt-4">Extras</h6>
          <hr class="mt-0" />
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa pt-1 fa-picture-o mr-1" aria-hidden="true"></i>
              <p class="mb-0">URL Logo</p>
            </div>
            <input
              type="text"
              class="form-control"
              v-model.trim="activeBranchConfig.GENERAL.TKT_IMG"
              placeholder="https://example.com/logo.jpg"
              :disabled="!editTicket"
            />
          </div>
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa pt-1 fa-usd pt-1 mr-1" aria-hidden="true"></i>
              <p class="mb-0">Tipo de ticket</p>
            </div>
            <el-select
              placeholder="Selecciona"
              class=""
              size="small"
              v-model="activeBranchConfig.GENERAL.TRX_TYPE"
              :disabled="!editTicket"
            >
              <el-option
                v-for="(cat, index) in TRXTypeDictionary"
                :key="index"
                :label="cat"
                :value="cat"
              ></el-option>
              <!-- <el-option
                label="Boleta Electronica"
                value="[BOLETA ELECTRÓNICA]"
              ></el-option>
              <el-option
                label="Comprobante de Venta"
                value="[COMPROBANTE DE VENTA]"
              ></el-option> -->
            </el-select>
          </div>
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i
                class="fa pt-1 fa-commenting-o pt-1 mr-1"
                aria-hidden="true"
              ></i>
              <p class="mb-0">Nota al pie</p>
            </div>
            <input
              type="text"
              class="form-control"
              placeholder="Ej: Gracias por preferirnos"
              v-model.trim="activeBranchConfig.GENERAL.MSJ_TKT"
              :disabled="!editTicket"
            />
          </div>
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa pt-1 fa-envelope-o pt-1 mr-1" aria-hidden="true"></i>
              <p class="mb-0">Correo Default</p>
            </div>
            <input
              type="email"
              class="form-control"
              placeholder="Ej: centralgym@2tec.cl"
              v-model.trim="activeBranchConfig.GENERAL.CR_EMISION_BOLETA"
              :disabled="!editTicket"
            />
          </div>
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa pt-1 fa-envelope-o pt-1 mr-1" aria-hidden="true"></i>
              <p class="mb-0">Nombre Default</p>
            </div>
            <input
              type="text"
              class="form-control"
              placeholder="Ej: SOPORTE 2TEC"
              v-model.trim="activeBranchConfig.GENERAL.NBR_EMISION_BOLETA"
              :disabled="!editTicket"
            />
          </div>
          <div class="d-flex flex-row mb-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa pt-1 fa-print pt-1 mr-1" aria-hidden="true"></i>
              <p class="mb-0">Cant. Copias</p>
            </div>
            <input
              type="number"
              class="form-control col-2"
              placeholder="1"
              min="1"
              max="5"
              :disabled="!editTicket"
              v-model.number="activeBranchConfig.GENERAL.COPIAS_TKT"
            />
          </div>
          <div class="d-flex flex-row my-2 align-items-end">
            <div class="col-4 d-flex flex-row text-secondary">
              <i class="fa fa-balance-scale mr-1" aria-hidden="true"></i>
              <p class="mb-0">Mostrar Impuesto</p>
            </div>
            <div>
              <p-switch
                type="success"
                class="mx-auto my-auto"
                size="small"
                on-text=""
                off-text=""
                v-model.trim="activeBranchConfig.GENERAL.TKT_SII_MOSTRAR"
                :disabled="!editGeneral"
              ></p-switch>
            </div>
          </div>
          <div class="col-12 d-flex flex-row justify-content-center py-2">
            <button
              v-if="!editTicket"
              class="btn btn-info mx-auto"
              @click="handleEditEnable('editTicket')"
            >
              editar
            </button>
            <template v-else>
              <button
                class="btn btn-success mr-4"
                @click="handleEditSave('editTicket')"
              >
                guardar
              </button>
              <button
                class="btn btn-danger"
                @click="handleEditCancel('editTicket')"
              >
                CANCELAR
              </button>
            </template>
          </div>
        </card>
      </collapse-item>
    </collapse>
    <!-- CONFIGURACIONES GENERALES  -->
    <card v-if="show === 'general'" class="col-md-7 d-none d-md-block">
      <p class="lead text-center">GENERAL</p>
      <h6 class="mb-1 mt-4">Cierres de caja</h6>
      <hr class="mt-0" />
      <div class="d-flex flex-row my-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-envelope-o mr-1" aria-hidden="true"></i>
          <p class="mb-0">Habilitar envío</p>
        </div>
        <div>
          <p-switch
            type="success"
            class="mx-auto my-auto"
            size="small"
            on-text=""
            off-text=""
            v-model="activeBranchConfig.GENERAL.PV_V_HEEPOS"
            :disabled="!editGeneral"
          ></p-switch>
        </div>
      </div>
      <div class="d-flex flex-row mb-1 mb-0 align-items-end">
        <div
          class="col-4 d-flex flex-row text-secondary"
          :class="correoCierresCaja.length > 1 ? 'mt-1 mb-auto' : ''"
        >
          <i class="fa fa-envelope-o mr-1" aria-hidden="true"></i>
          <p class="mb-0">Correo envio</p>
        </div>
        <div>
          <div
            v-for="(correo, index) in correoCierresCaja"
            class="d-flex flex-row"
            :class="correoCierresCaja.length > 1 ? 'mb-2' : ''"
            :key="index"
          >
            <input
              type="email"
              class="form-control mr-2"
              v-model.trim="correoCierresCaja[index]"
              :disabled="!editGeneral"
            />
            <button
              class="btn btn-success my-0 w-auto py-1 px-2"
              @click="addCorreoCierresCaja"
              :disabled="!editGeneral"
            >
              <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
            <button
              class="btn btn-danger my-0 w-auto py-1 px-2"
              @click="correoCierresCaja.splice(index, 1)"
              :disabled="correoCierresCaja.length === 1 || !editGeneral"
            >
              <i class="fa fa-minus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="d-flex flex-row my-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-file-excel-o mr-1" aria-hidden="true"></i>
          <p class="my-auto">Adjuntar Excel</p>
        </div>
        <div>
          <p-switch
            type="success"
            class="mx-auto my-auto"
            size="small"
            on-text=""
            off-text=""
            v-model="activeBranchConfig.GENERAL.PV_V_EARVD"
            :disabled="!editGeneral"
          ></p-switch>
        </div>
      </div>
      <div class="d-flex flex-row my-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-envelope-o mr-1" aria-hidden="true"></i>
          <p class="mb-0">Enviar Resumen</p>
        </div>
        <div>
          <p-switch
            type="success"
            class="mx-auto my-auto"
            size="small"
            on-text=""
            off-text=""
            v-model="activeBranchConfig.GENERAL.PV_V_EMRCC"
            :disabled="!editGeneral"
          ></p-switch>
        </div>
      </div>
      <div class="d-flex flex-row my-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-envelope-o mr-1" aria-hidden="true"></i>
          <p class="mb-0">Visualizar Montos</p>
        </div>
        <div>
          <p-switch
            type="success"
            class="mx-auto my-auto"
            size="small"
            on-text=""
            off-text=""
            v-model="activeBranchConfig.GENERAL.PV_MMRC"
            :disabled="!editGeneral"
          ></p-switch>
        </div>
      </div>
      <div class="d-flex flex-row mb-1 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-print mr-1" aria-hidden="true"></i>
          <p class="mb-0">Imprimir Resumen</p>
        </div>
        <div>
          <p-switch
            type="success"
            class="mx-auto my-auto"
            size="small"
            on-text=""
            off-text=""
            v-model="activeBranchConfig.GENERAL.ALM_USAR_TKT_RESCCAJA"
            :disabled="!editGeneral"
          ></p-switch>
        </div>
      </div>

      <h6 class="mb-1 mt-4">Ventas</h6>
      <hr class="mt-0" />
      <div class="d-flex flex-row mb-1 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-envelope-o mr-1 mt-1" aria-hidden="true"></i>
          <p class="mb-0">Habilitar descuento/recargo</p>
        </div>
        <div class="d-flex flex-row col-8">
          <div class="m-auto">
            <p-switch
              type="success"
              class="mx-auto my-auto"
              size="small"
              on-text=""
              off-text=""
              v-model="activeBranchConfig.GENERAL.DSC_PV"
              :disabled="!editGeneral"
            ></p-switch>
          </div>
          <p-checkbox
            class="col my-2"
            v-model="activeBranchConfig.GENERAL.PV_DSC"
            label="1"
            :disabled="!editGeneral || !activeBranchConfig.GENERAL.DSC_PV"
            >Desc.</p-checkbox
          >
          <p-checkbox
            class="col my-2"
            v-model="activeBranchConfig.GENERAL.PV_REC"
            label="2"
            :disabled="!editGeneral || !activeBranchConfig.GENERAL.DSC_PV"
            >Recargo</p-checkbox
          >
        </div>
      </div>
      <small v-if="errorDesREC" class="text-end col-12 text-danger">{{
        errorDesREC
      }}</small>
      <div class="d-flex flex-row mb-1 mb-0 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-building-o mr-1" aria-hidden="true"></i>
          <p class="mb-0">Porcentaje Defecto</p>
        </div>
        <input
          type="number"
          class="form-control col-2"
          :disabled="!editGeneral || !activeBranchConfig.GENERAL.DSC_PV"
          v-model.number="activeBranchConfig.GENERAL.DSC_PV_PORC_DEF"
        />
      </div>
      <div class="d-flex flex-row mb-1 mb-0 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-building-o mr-1" aria-hidden="true"></i>
          <p class="mb-0">Porcentaje Max.</p>
        </div>
        <input
          type="number"
          class="form-control col-2"
          :disabled="!editGeneral || !activeBranchConfig.GENERAL.DSC_PV"
          v-model.number="activeBranchConfig.GENERAL.DSC_PV_MAX_PERM"
        />
      </div>
      <div class="d-flex flex-row my-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-money mr-1" aria-hidden="true"></i>
          <p class="mb-0">Sólo efectivo</p>
        </div>
        <div>
          <p-switch
            type="success"
            class="mx-auto my-auto"
            size="small"
            on-text=""
            off-text=""
            v-model="activeBranchConfig.GENERAL.PV_V_MPEFEC"
            :disabled="!editGeneral"
          ></p-switch>
        </div>
      </div>
      <el-tooltip :open-delay="200" placement="top">
        <template #content>
          Habilita/Desahbilita la capacidad de ingresar montos en forma manual
        </template>
        <div class="d-flex flex-row my-2 align-items-end">
          <div class="col-4 d-flex flex-row text-secondary">
            <i class="fa fa-money mr-1" aria-hidden="true"></i>
            <p class="mb-0">Ventas Manuales</p>
          </div>
          <div>
            <p-switch
              type="success"
              class="mx-auto my-auto"
              size="small"
              on-text=""
              off-text=""
              v-model="activeBranchConfig.GENERAL.NO_OPER"
              :disabled="!editGeneral"
            ></p-switch>
          </div>
        </div>
      </el-tooltip>
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa pt-1 fa-balance-scale mb-0 mr-1" aria-hidden="true"></i>
          <p class="mb-0">Impuesto/IVA</p>
        </div>
        <input
          type="number"
          class="form-control col-2"
          :disabled="!editGeneral"
          v-model.number="activeBranchConfig.GENERAL.IMP"
        />
      </div>
      <template v-if="accountType === 'SOPORTE'">
        <h6 class="mb-1 mt-4">Conexión SQL</h6>
        <hr class="mt-0" />
        <div class="d-flex flex-row mb-2 align-items-end">
          <div class="col-4 d-flex flex-row text-secondary">
            <i class="fa pt-1 fa-desktop mr-1" aria-hidden="true"></i>
            <p class="mb-0">Data Source</p>
          </div>
          <input
            type="text"
            class="form-control"
            :disabled="!editGeneral"
            v-model.trim="activeBranchConfig.BD.DTASOURCE"
          />
        </div>
        <div class="d-flex flex-row mb-2 align-items-end">
          <div class="col-4 d-flex flex-row text-secondary">
            <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
            <p class="mb-0">Network Library</p>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Ej: [IP]/SQL_MIR1"
            :disabled="!editGeneral"
            v-model.trim="activeBranchConfig.BD.NETWORKLIBRARY"
          />
        </div>
        <div class="d-flex flex-row mb-2 align-items-end">
          <div class="col-4 d-flex flex-row text-secondary">
            <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
            <p class="mb-0">Catalog</p>
          </div>
          <input
            type="text"
            class="form-control"
            :disabled="!editGeneral"
            v-model.trim="activeBranchConfig.BD.CATALOG"
          />
        </div>
        <div class="d-flex flex-row mb-2 align-items-end">
          <div class="col-4 d-flex flex-row text-secondary">
            <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
            <p class="mb-0">User</p>
          </div>
          <input
            type="text"
            class="form-control"
            :disabled="!editGeneral"
            v-model.trim="activeBranchConfig.BD.USER"
          />
        </div>
        <div class="d-flex flex-row mb-2 align-items-end">
          <div class="col-4 d-flex flex-row text-secondary">
            <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
            <p class="mb-0">Password</p>
          </div>
          <input
            type="password"
            class="form-control"
            placeholder="***************"
            :disabled="!editGeneral"
            v-model="activeBranchConfig.BD.PASSWORD"
          />
        </div>
        <div class="d-flex flex-row mb-2 align-items-end">
          <div class="col-4 d-flex flex-row text-secondary">
            <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
            <p class="mb-0">Timeout</p>
          </div>
          <input
            type="number"
            class="form-control col-2"
            :disabled="!editGeneral"
            v-model="activeBranchConfig.BD.TIMEOUT"
          />
        </div>
      </template>
      <h6 class="mb-1 mt-4">BIOMETRIA (huellas)</h6>
      <hr class="mt-0" />
      <el-tooltip :open-delay="200" placement="top">
        <template #content>
          Si está deshabilitado no será posible cambiar la huella de un socio
          luego de ser enrolado
        </template>
        <div class="d-flex flex-row my-2 align-items-end">
          <div class="col-4 d-flex flex-row text-secondary">
            <i
              class="nc-icon nc-touch-id mr-1"
              aria-hidden="true"
              style="font-size: 20px"
            ></i>
            <p class="mb-0">Permitir cambio</p>
          </div>
          <div>
            <p-switch
              type="success"
              class="mx-auto my-auto"
              size="small"
              on-text=""
              off-text=""
              v-model="activeBranchConfig.GENERAL.FS_BIO_ACT"
              :disabled="!editGeneral"
            ></p-switch>
          </div>
        </div>
      </el-tooltip>
      <el-tooltip :open-delay="200" placement="top">
        <template #content>
          Cantidad maxima de huellas enroladas por socio
        </template>
        <div class="d-flex flex-row mb-2 align-items-end">
          <div class="col-4 d-flex flex-row text-secondary">
            <i
              class="nc-icon nc-touch-id mb-0 mr-1"
              aria-hidden="true"
              style="font-size: 20px"
            ></i>
            <p class="mb-0">Cantidad</p>
          </div>
          <input
            type="number"
            class="form-control col-2"
            min="1"
            max="10"
            :disabled="!editGeneral"
            v-model.number="activeBranchConfig.GENERAL.FS_BIO_NRO_MAX"
          /></div
      ></el-tooltip>
      <h6 class="mb-1 mt-4">MISCELáNEOS</h6>
      <hr class="mt-0" />
      <el-tooltip :open-delay="200" placement="top">
        <template #content>
          Texto que se mostrará en la parte superior en los putos de venta
        </template>
        <div class="d-flex flex-row mb-2 align-items-end">
          <div class="col-4 d-flex flex-row text-secondary">
            <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
            <p class="mb-0">Nombre Sistema</p>
          </div>
          <input
            type="text"
            class="form-control"
            :disabled="!editGeneral"
            v-model.trim="activeBranchConfig.GENERAL.SISTEM_NAME"
          />
        </div>
      </el-tooltip>
      <div class="d-flex flex-row my-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-desktop mr-1" aria-hidden="true"></i>
          <p class="mb-0">Fullscreen</p>
        </div>
        <div>
          <p-switch
            type="success"
            class="mx-auto my-auto"
            size="small"
            on-text=""
            off-text=""
            v-model="activeBranchConfig.GENERAL.PV_V_FS"
            :disabled="!editGeneral"
          ></p-switch>
        </div>
      </div>
      <el-tooltip :open-delay="200" placement="top">
        <template #content>
          Oculta los mensajes del sistema salvo por los mensajes de [ERROR]
        </template>
        <div class="d-flex flex-row my-2 align-items-end">
          <div class="col-4 d-flex flex-row text-secondary">
            <i class="fa fa-comments-o mr-1" aria-hidden="true"></i>
            <p class="mb-0">Mensajes Sistema</p>
          </div>
          <div>
            <p-switch
              type="success"
              class="mx-auto my-auto"
              size="small"
              on-text=""
              off-text=""
              v-model="activeBranchConfig.GENERAL.MSJS"
              :disabled="!editGeneral"
            ></p-switch>
          </div></div
      ></el-tooltip>
      <h6 class="mb-1 mt-4">Inventario</h6>
      <hr class="mt-0" />
      <div class="d-flex flex-row my-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-comments-o mr-1" aria-hidden="true"></i>
          <p class="mb-0">Ver Minituras</p>
        </div>
        <div>
          <p-switch
            type="success"
            class="mx-auto my-auto"
            size="small"
            on-text=""
            off-text=""
            v-model="activeBranchConfig.GENERAL.UT_IMG_PV"
            :disabled="!editGeneral"
          ></p-switch>
        </div>
      </div>
      <small
        class="text-danger"
        v-for="(error, i) in errorStringsGeneral"
        :key="i"
      >
        {{ error }}
      </small>
      <div class="col-12 d-flex justify-content-center">
        <button
          v-if="!editGeneral"
          class="btn btn-info mx-auto"
          @click="handleEditEnable('editGeneral')"
        >
          editar
        </button>
        <template v-else>
          <button
            class="btn btn-success mr-4"
            @click="handleEditSave('editGeneral')"
            :disabled="errorStringsGeneral.length > 0"
          >
            guardar
          </button>
          <button
            class="btn btn-danger"
            @click="handleEditCancel('editGeneral')"
          >
            CANCELAR
          </button>
        </template>
      </div>
    </card>
    <!-- CONFIGURACION TICKET DE VENTA -->
    <card v-if="show === 'ticket'" class="col-md-7 d-none d-md-block">
      <p class="lead text-center">CONFIGURACIÓN DE TICKETS</p>
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-auto px-0 d-flex flex-row text-secondary mr-2">
          <p class="my-auto text-uppercase lead">
            <!-- <i class="fa pt-1 fa-usd pt-1 mr-1" aria-hidden="true"></i> -->
            Tipo de transacción
          </p>
        </div>
        <el-select
          placeholder="Selecciona"
          class="my-auto"
          size="small"
          v-model="activeBranchConfig.GENERAL.TRX_TYPE"
          :disabled="!editTicket"
        >
          <el-option
            v-for="(cat, index) in TRXTypeDictionary"
            :key="index"
            :label="cat"
            :value="cat"
          ></el-option>
        </el-select>
      </div>
      <h6 class="mb-1 mt-4">Empresa</h6>
      <hr class="mt-0" />
      <div class="d-flex flex-row mb-1 mb-0 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-building-o mr-1" aria-hidden="true"></i>
          <p class="mb-0">Razón Social</p>
        </div>
        <input
          type="text"
          class="form-control"
          v-model="activeBranchConfig.GENERAL.TKT_RS"
          :disabled="!editTicket"
        />
      </div>
      <small class="text-danger" v-if="!activeBranchConfig.GENERAL.TKT_RS"
        >Este campo es obligatorio</small
      >
      <div class="d-flex flex-row mb-1 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-building-o mr-1" aria-hidden="true"></i>
          <p class="mb-0">Giro</p>
        </div>
        <input
          type="text"
          class="col-8 border-bottom form-control"
          v-model="activeBranchConfig.GENERAL.TKT_GRO"
          :disabled="!editTicket"
        />
      </div>
      <small class="text-danger" v-if="!activeBranchConfig.GENERAL.TKT_GRO"
        >Este campo es obligatorio</small
      >
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-building-o mr-1" aria-hidden="true"></i>
          <p class="mb-0">Rut</p>
        </div>
        <input
          type="text"
          class="form-control text-uppercase"
          v-model="activeBranchConfig.GENERAL.TKT_RUT"
          v-mask="'##.###.###-N'"
          placeholder="Ej: 12.345.678-9"
          :disabled="!editTicket"
        />
      </div>
      <small class="text-danger" v-if="!activeBranchConfig.GENERAL.TKT_RUT"
        >Este campo es obligatorio</small
      >
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-building-o mr-1" aria-hidden="true"></i>
          <p class="mb-0">S.I.I.</p>
        </div>
        <input
          type="text"
          class="form-control"
          placeholder="Ej: S.I.I. [CIUDAD]"
          v-model="activeBranchConfig.GENERAL.TKT_SII"
          :disabled="!editTicket"
        />
      </div>
      <h6 class="mb-1 mt-4">Ubicación y contacto</h6>
      <hr class="mt-0" />
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa pt-1 fa-map-marker mr-1" aria-hidden="true"></i>
          <p class="mb-0">Dirección</p>
        </div>
        <input
          type="text"
          class="form-control"
          :disabled="!editTicket"
          v-model="activeBranchConfig.GENERAL.TKT_DIR"
        />
      </div>
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa pt-1 fa-phone mb-0 mr-1" aria-hidden="true"></i>
          <p class="mb-0">Teléfono</p>
        </div>
        <input
          type="text"
          class="form-control"
          :disabled="!editTicket"
          v-model="activeBranchConfig.GENERAL.TKT_FON"
        />
      </div>
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa pt-1 fa-desktop mb-0 mr-1" aria-hidden="true"></i>
          <p class="mb-0">Sitio || RR.SS.</p>
        </div>
        <input
          type="text"
          class="form-control"
          :disabled="!editTicket"
          v-model="activeBranchConfig.GENERAL.TKT_PW"
        />
      </div>
      <!-- <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa pt-1 fa-at mb-0 mr-1" aria-hidden="true"></i>
          <p class="mb-0">RR.SS.</p>
        </div>
        <input
          type="text"
          class="form-control"
          placeholder="Ej: fb.com/CentralGym"
          :disabled="!editTicket"
        />
      </div> -->
      <h6 class="mb-1 mt-4">Horarios</h6>
      <hr class="mt-0" />
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa pt-1 fa-clock-o mb-0 mr-1" aria-hidden="true"></i>
          <p class="mb-0">Lunes a Viernes</p>
        </div>
        <div class="col-8 d-flex flex-row">
          <p-switch
            type="success"
            class="mx-auto my-auto"
            size="small"
            on-text=""
            off-text=""
            v-model="switchMonToFri"
            :disabled="!editTicket"
          ></p-switch>
          <div v-if="switchMonToFri" class="col-10 d-flex flex-row">
            <input
              v-mask="'##:##'"
              placeholder="HH:MM"
              v-model="operatingHoursMonToFri[0]"
              class="form-control col-5"
              :disabled="!editTicket"
            />
            <p class="col-2 m-auto">a</p>
            <input
              v-mask="'##:##'"
              placeholder="HH:MM"
              v-model="operatingHoursMonToFri[2]"
              class="form-control col-5"
              :disabled="!editTicket"
            />
          </div>
          <p v-else class="col-10 text-center m-auto">CERRADO</p>
        </div>
      </div>
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa pt-1 fa-clock-o mb-0 mr-1" aria-hidden="true"></i>
          <p class="mb-0">Sabado</p>
        </div>
        <div class="col-8 d-flex flex-row">
          <p-switch
            type="success"
            class="mx-auto my-auto"
            size="small"
            on-text=""
            off-text=""
            v-model="switchSaturday"
            :disabled="!editTicket"
          ></p-switch>
          <div v-if="switchSaturday" class="col-10 d-flex flex-row">
            <input
              v-mask="'##:##'"
              placeholder="HH:MM"
              v-model="operatingHoursSaturday[0]"
              class="form-control col-5"
              :disabled="!editTicket"
            />
            <p class="col-2 m-auto">a</p>
            <input
              v-mask="'##:##'"
              placeholder="HH:MM"
              v-model="operatingHoursSaturday[2]"
              class="form-control col-5"
              :disabled="!editTicket"
            />
          </div>
          <p v-else class="col-10 text-center m-auto">CERRADO</p>
        </div>
      </div>
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa pt-1 fa-clock-o mb-0 mr-1" aria-hidden="true"></i>
          <p class="mb-0">Domingo</p>
        </div>
        <div class="col-8 d-flex flex-row">
          <p-switch
            type="success"
            class="mx-auto my-auto"
            size="small"
            on-text=""
            off-text=""
            v-model="switchSunday"
            :disabled="!editTicket"
          ></p-switch>
          <div v-if="switchSunday" class="col-10 d-flex flex-row">
            <input
              v-mask="'##:##'"
              placeholder="HH:MM"
              v-model="operatingHoursSunday[0]"
              class="form-control col-5"
              :disabled="!editTicket"
            />
            <p class="col-2 m-auto">a</p>
            <input
              v-mask="'##:##'"
              placeholder="HH:MM"
              v-model="operatingHoursSunday[2]"
              class="form-control col-5"
              :disabled="!editTicket"
            />
          </div>
          <p v-else class="col-10 text-center m-auto">CERRADO</p>
        </div>
      </div>
      <h6 class="mb-1 mt-4">Extras</h6>
      <hr class="mt-0" />
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa pt-1 fa-picture-o mr-1" aria-hidden="true"></i>
          <p class="mb-0">URL Logo</p>
        </div>
        <input
          type="text"
          class="form-control"
          v-model="activeBranchConfig.GENERAL.TKT_IMG"
          placeholder="https://example.com/logo.jpg"
          :disabled="!editTicket"
        />
      </div>
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa pt-1 fa-commenting-o pt-1 mr-1" aria-hidden="true"></i>
          <p class="mb-0">Nota al pie</p>
        </div>
        <input
          type="text"
          class="form-control"
          placeholder="Ej: Gracias por preferirnos"
          v-model="activeBranchConfig.GENERAL.MSJ_TKT"
          :disabled="!editTicket"
        />
      </div>
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa pt-1 fa-envelope-o pt-1 mr-1" aria-hidden="true"></i>
          <p class="mb-0">Correo Default</p>
        </div>
        <input
          type="email"
          class="form-control"
          placeholder="Ej: centralgym@2tec.cl"
          v-model.trim="activeBranchConfig.GENERAL.CR_EMISION_BOLETA"
          :disabled="!editTicket"
        />
      </div>
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa pt-1 fa-envelope-o pt-1 mr-1" aria-hidden="true"></i>
          <p class="mb-0">Nombre Default</p>
        </div>
        <input
          type="text"
          class="form-control"
          placeholder="Ej: SOPORTE 2TEC"
          v-model="activeBranchConfig.GENERAL.NBR_EMISION_BOLETA"
          :disabled="!editTicket"
        />
      </div>
      <div class="d-flex flex-row mb-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa pt-1 fa-print pt-1 mr-1" aria-hidden="true"></i>
          <p class="mb-0">Cant. Copias</p>
        </div>
        <input
          type="number"
          class="form-control col-2"
          placeholder="1"
          min="1"
          max="5"
          :disabled="!editTicket"
          v-model.number="activeBranchConfig.GENERAL.COPIAS_TKT"
        />
      </div>
      <div class="d-flex flex-row my-2 align-items-end">
        <div class="col-4 d-flex flex-row text-secondary">
          <i class="fa fa-balance-scale mr-1" aria-hidden="true"></i>
          <p class="mb-0">Mostrar Impuesto</p>
        </div>
        <div>
          <p-switch
            type="success"
            class="mx-auto my-auto"
            size="small"
            on-text=""
            off-text=""
            v-model="activeBranchConfig.GENERAL.TKT_SII_MOSTRAR"
            :disabled="!editGeneral"
          ></p-switch>
        </div>
      </div>
      <div class="col-12 d-flex flex-row justify-content-center py-2">
        <button
          v-if="!editTicket"
          class="btn btn-info mx-auto"
          @click="handleEditEnable('editTicket')"
        >
          editar
        </button>
        <template v-else>
          <button
            class="btn btn-success mr-4"
            @click="handleEditSave('editTicket')"
          >
            guardar
          </button>
          <button
            class="btn btn-danger"
            @click="handleEditCancel('editTicket')"
          >
            CANCELAR
          </button>
        </template>
      </div>
    </card>
    <integraciones
      ref="integraciones"
      @saveIntegrationChanges="handleUpdateIntegrations"
    ></integraciones>
  </main>
</template>

<script>
import Integraciones from "./POS/Integraciones.vue";
import {
  Badge,
  Modal,
  CollapseItem,
  Collapse,
} from "src/components/UIComponents";
import PPagination from "src/components/UIComponents/Pagination.vue";
import Loading from "src/components/Dashboard/Layout/LoadingMainPanel.vue";
import Dropdown from "src/components/UIComponents/Dropdown.vue";
import PSwitch from "src/components/UIComponents/Switch.vue";
import {
  DatePicker,
  TimeSelect,
  Slider,
  Tag,
  Input,
  Button,
  Select,
  Option,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
import Card from "../../../UIComponents/Cards/Card.vue";
import Vue from "vue";
import { VueMaskDirective } from "v-mask";
import _ from "lodash";
import { trickle } from "nprogress";

Vue.directive("mask", VueMaskDirective);
export default {
  components: {
    Integraciones,
    Badge,
    CollapseItem,
    Collapse,
    PSwitch,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    [Slider.name]: Slider,
    [Tag.name]: Tag,
    [Input.name]: Input,
    [Button.name]: Button,
    Modal,
    [Option.name]: Option,
    [Select.name]: Select,
    [Tooltip.name]: Tooltip,
  },
  computed: {
    customerUpdateChangeCheck() {
      let updatedFields = {};
      Object.keys(this.activeBranchConfig).forEach((key) => {
        if (
          !_.isEqual(
            this.activeBranchConfig[key],
            this.activeBranchConfigOG[key]
          )
        ) {
          updatedFields[key] = this.activeBranchConfig[key];
        }
      });
      if (Object.keys(updatedFields).length) {
        return true;
      } else {
        return false;
      }
    },
    errorStringsGeneral() {
      let error = [];
      let emptyMails = false;
      this.correoCierresCaja.forEach((correo) => {
        if (!correo) {
          emptyMails = true;
        }
      });
      if (emptyMails) {
        error.push("No puedes dejar campos de correo en blanco");
      }
      if (this.correoCierresCaja.length === 0) {
        error.push("Debes ingresar al menos un correo");
      }
      if (this.activeBranchConfig.GENERAL.DSC_PV) {
        if (
          !this.activeBranchConfig.GENERAL.PV_DSC &&
          !this.activeBranchConfig.GENERAL.PV_REC
        ) {
          error.push("");
        }
      }
      return error;
    },
    errorDesREC() {
      if (this.activeBranchConfig.GENERAL.DSC_PV) {
        if (
          !this.activeBranchConfig.GENERAL.PV_DSC &&
          !this.activeBranchConfig.GENERAL.PV_REC
        ) {
          return "Debes escoger al menos una opción";
        }
      }
    },
    errorStringsTicket() {
      let errorCount = 0;
    },
  },
  watch: {
    activeBranchConfig: {
      handler: (newValue) => {
        // console.log(newValue);
      },
      deep: true,
    },
    "activeBranchConfig.GENERAL.DSC_PV": function (newValue) {
      if (this.editGeneral) {
        if (!newValue) {
          this.activeBranchConfig.GENERAL.PV_DSC = false;
          this.activeBranchConfig.GENERAL.PV_REC = false;
          this.activeBranchConfig.GENERAL.DSC_PV_PORC_DEF = 0;
          this.activeBranchConfig.GENERAL.DSC_PV_MAX_PERM = 0;
        }
      }
    },
    correoCierresCaja: function (newValue) {
      this.activeBranchConfig.GENERAL.PV_V_EEDV = newValue.join(", ");
    },
    switchMonToFri: function (newValue) {
      if (this.editTicket) {
        // console.log("moding");
        if (!newValue) {
          this.activeBranchConfig.GENERAL.TKT_HN1 = "CERRADO";
        } else {
          this.operatingHoursMonToFri = ["00:00", "a", "23:59"];
        }
      }
    },
    switchSaturday: function (newValue) {
      if (this.editTicket) {
        if (!newValue) {
          this.activeBranchConfig.GENERAL.TKT_HN2 = "CERRADO";
        } else {
          this.operatingHoursSaturday = ["00:00", "a", "23:59"];
        }
      }
    },
    switchSunday: function (newValue) {
      if (this.editTicket) {
        if (!newValue) {
          this.activeBranchConfig.GENERAL.TKT_HN3 = "CERRADO";
        } else {
          this.operatingHoursSunday = ["00:00", "a", "23:59"];
        }
      }
    },
    // show: function (newValue, oldValue) {
    //   this.$refs.integraciones.close();
    //   switch (newValue) {
    //     case "integraciones":
    //       if (newValue === oldValue) {
    //         console.log("igual");
    //         this.$refs.integraciones.close();
    //         const data = this.activeBranchConfig.INTEGRACIONES;
    //         this.$refs.integraciones.start(data);
    //       } else {
    //         console.log("desigual");
    //         const data = this.activeBranchConfig.INTEGRACIONES;
    //         this.$refs.integraciones.start(data);
    //       }
    //       break;
    //     default:
    //       this.$refs.integraciones.close();
    //       break;
    //   }
    // },
  },
  data() {
    return {
      TRXTypeDictionary: [],
      branches: [],
      branchesConfigs: {},
      editGeneral: false,
      editTicket: false,
      activeBranchConfigOG: {},
      activeBranchConfig: {},
      correoCierresCaja: [""],
      timeInput: "",
      rutInput: "",
      show: "",
      activeBranchEditID: "",
      switchMonToFri: false,
      operatingHoursMonToFri: [],
      operatingHoursSaturday: [],
      operatingHoursSunday: [],
      switchSaturday: false,
      switchSunday: false,
      configDefault: {
        serviceName: "CentralGymPOS",
        GENERAL: {
          MSJS: true,
          SISTEM_NAME: "CENTRAL GYM POS",
          IMP: 19,
          DSC_PV: true, //Deshabilitar descargo o recuento
          UT_INV_PV: true,
          DSC_PV_PORC_DEF: 0, //Descuento o recargo por defecto
          PV_DSC: false, // Activar descuento
          PV_REC: true, // Activar recargo
          ALM_USAR_TKT_RESCCAJA: true, // Imprimir resumen cierre caja
          COPIAS_TKT: 1,
          CR_EMISION_BOLETA: "DTE@CLIENTES.CENTRALGYM.CL",
          DEFAULT_CIUDAD: "SANTIAGO",
          DEFAULT_COMUNA: "San Miguel",
          DEFAULT_REGION: "Metropolitana",
          DISABLE_PLAN_LOCAL: true,
          DISABLE_PLAN_SEC: false,
          DISABLE_POS: false, //No permite la asignacion de planes secundarios
          DISABLE_REN: false,
          DSC_PV_MAX_PERM: 50, //Maximo descuento o recargo permitido
          FECHA_PLAN01: false,
          HAB_EMISION_BOLETA: true,
          MAX_PAG: 10,
          MAX_RENPL: 7,
          MENSAJES_INFO: true,
          MSJ_TKT: "Les deseamos un excelente dia!",
          NBR_EMISION_BOLETA: "CENTRALGYM",
          PV_MMRC: true,
          PV_NO_OPER: true,
          PV_V_C: "0",
          PV_V_CHLP: true,
          PV_V_EARPV: false,
          PV_V_EARVD: true,
          PV_V_EEDV: "soporte@2tec.cl",
          PV_V_EMRCC: true,
          PV_V_FS: false,
          PV_V_HEEPOS: true,
          PV_V_MPEFEC: false,
          RENPL_HPC: false,
          RESTABLECER_FECHA_RENOVACION: true,
          TKT_DIR: "Av. Club Hípico #4676, Oficina 817, Pedro Aguirre Cerda",
          TKT_FON: "(+56) 9 6498 2669",
          TKT_GRO: "Gestión Administrativa y Control de Acceso para Gimnasios",
          TKT_HN1: "09:00 a 19:00",
          TKT_HN2: "CERRADO",
          TKT_HN3: "CERRADO",
          TKT_IMG:
            "https://ca.slack-edge.com/T05LTMK6F8R-U05LC57KY7P-c48a0addab1c-192",
          TKT_PW: "https://centralgym.cl",
          TKT_RS: "CentralGym App",
          TKT_RUT: "99.999.999-9",
          TKT_SII: "S.I.I. SANTIAGO",
          TKT_SII_MOSTRAR: true,
          TRX_TYPE: "[COMPROBANTE DE VENTA]",
          UT_IMG_PV: true,
          FS_BIO_ACT: true,
          FS_BIO_NRO_MAX: 1,
          DSC_MAT_PV: false,
        },
        COTIZACION: {
          CORRELATIVO: "0",
          P_RAZONSOCIAL: "",
          P_RUT: "",
          P_DIRECCION: "",
          P_MAIL: "",
          P_TELEFONO: "",
          P_CELULAR: "",
          P_CIUDAD: "",
          P_REGION: "",
          P_COMUNA: "",
          BANCO: "",
          CUENTA: "",
          N_CUENTA: "",
          TITULAR: "",
          RUT_TITULAR: "",
          L_CORRELATIVO: "",
        },
        MAIL_CREDENCIAL: {
          HOST: "3.3.3.3",
          PORT: "3",
          SSL: "False",
          MAIL_CR: "sistemas@2tec.cl",
          TITULO_CR: "",
          HEADER_MAILS: "",
          PASSWD_CR: "",
        },
        BROKER_MQTT: {
          ID_TERMINAL: "TERMINAL 1",
          HOST: "208.94.246.49",
          PORT: "1833",
          USER: "",
          PWD: "",
        },
        GENERAL_FS: {
          COFS1: true,
          COFS2: true,
          COFS3: false,
          COFS4: false,
          COFS5: false,
          COFS6: false,
          COFS7: false,
          COFS8: true,
          COFS9: false,
          COFS10: false,
        },
        ACCES_METHOD: {
          RUT_CLAVE: false,
          TARJETA_RFID: false,
          BIOMETRIC: true,
          FACIAL_RECOGNITION: false,
        },
        BD: {
          DTASOURCE: "",
          NETWORKLIBRARY: "",
          CATALOG: "",
          USER: "",
          PASSWORD: "",
          TIMEOUT: "32",
        },
        INTEGRACIONES: {
          BSALE: {
            CODIGOS: {
              ID_OFICINA: 3,
              ID_LISTA_PRECIO: 227,
              ID_IMP_IVA: 1,
              ID_IMP_EXCENTO: 0,
              ID_MP_EFECTIVO: 1,
              ID_MP_DEBITO: 6,
              ID_MP_CREDITO: 2,
              ID_MP_CHEQUE: 5,
              ID_MP_TRANSFERENCIA: 8,
            },
            INDICADOR_ACTIVA_BSALE: false,
            TOKEN_BSALE: "",
            URL_BSALE_API: "",
          },
          FLOW: {
            API_KEY: "",
            SECRET_KEY: "",
            PLATAFORMA_DE_PAGO: true,
            HABILITADA: false,
            URL_API: "https://sandbox.flow.cl/api",
          },
          HABILITAR_PLATAFORMAS_DE_PAGO: false,
        },
      },
      accountType: "",
    };
  },
  methods: {
    test() {
      console.log("testeado");
    },
    handleCollapseItemChange() {
      this.editTicket = false;
      this.editGeneral = false;
      this.activeBranchConfig = {};
      this.activeBranchConfigOG = {};
      this.activeBranchEditID = "";
      this.show = "";
    },
    async handleUpdateIntegrations(newData) {
      // console.log("handeliado por el parent");
      // console.log(newData);
      const updatedData = newData;
      this.activeBranchConfig.INTEGRACIONES = updatedData;
      this.$refs.integraciones.close();
      await this.handleEditSave();
    },
    async handleEditSave(section) {
      this.$swal.fire({
        title: "Cargando...",
        text: "Espera un momento",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      if (this.switchMonToFri) {
        this.activeBranchConfig.GENERAL.TKT_HN1 =
          this.operatingHoursMonToFri.join(" ");
      }
      if (this.switchSaturday) {
        this.activeBranchConfig.GENERAL.TKT_HN2 =
          this.operatingHoursSaturday.join(" ");
      }
      if (this.switchSunday) {
        this.activeBranchConfig.GENERAL.TKT_HN3 =
          this.operatingHoursSunday.join(" ");
      }
      // console.log(this.activeBranchConfig);
      const isNew = !!this.activeBranchConfig.new;
      await this.$MasterControlAPI
        .post("", {
          Header: {
            Operacion: "/v1/update/PoS/config",
          },
          Auth: {
            Token: sessionStorage.getItem("jCxbraoQeD"),
          },
          Parameters: {
            sucursal: this.activeBranchConfig.sucursal,
            nombreSucursal: this.activeBranchConfig.nombreSucursal,
            new: isNew,
          },
          Body: this.activeBranchConfig,
        })
        .then((res) => {
          // console.log(res.data);
          if (res.data && res.data.Response.DataOut) {
            this.branchesConfigs[this.activeBranchEditID] = {
              ...res.data.Response.DataOut,
              sucursal: this.activeBranchConfig.sucursal,
            };
            // console.log(res);
            if (section) {
              this[section] = false;
            }
            this.activeBranchConfigOG = {};
            this.$swal
              .fire({
                title: "Exito!",
                text: "La configuración ha sido cargada exitosamente",
                icon: "success",
                confirmButtonColor: "#6bd098",
              })
              .then((res) => {
                this.showInfoPopUp();
              });
          } else {
            this.$swal.fire({
              title: "Error :(!",
              text:
                res.data.error ||
                "Ha ocurrido un error inesperado, ponte en contacto con soporte",
              icon: "error",
              confirmButtonColor: "#6bd098",
            });
          }
        })
        .catch((ex) => {
          console.error(ex.response.data.Response.Resultado.MensajeServicio);
          let errString;
          if (
            ex.response &&
            ex.response.data &&
            ex.response.data.Response &&
            ex.response.data.Response.Resultado
          ) {
            errString =
              ex.response.data.Response.Resultado.MensajeServicio || ex.message;
          } else {
            errString = ex.message;
          }
          this.$swal.fire({
            title: "Error :(!",
            text:
              errString ||
              "Ha ocurrido un error inesperado, ponte en contacto con soporte",
            icon: "error",
            confirmButtonColor: "#6bd098",
          });
        });
    },
    handleEditCancel(section) {
      this[section] = false;
      this.activeBranchConfig = _.cloneDeep(this.activeBranchConfigOG);
      this.activeBranchConfigOG = {};
      this.activeBranchEditID = "";
    },
    handleEditEnable(section) {
      this[section] = true;
      this.activeBranchConfigOG = {};
      this.activeBranchConfigOG = _.cloneDeep(this.activeBranchConfig);
    },
    handleBranchEditSelect(id, section) {
      this.editGeneral = false;
      this.editTicket = false;
      this.activeBranchConfigOG = {};
      this.activeBranchConfig = {};
      this.activeBranchEditID = id;
      this.activeBranchConfig = _.cloneDeep(this.branchesConfigs[id]);
      this.correoCierresCaja = [
        ...this.activeBranchConfig.GENERAL.PV_V_EEDV.split(", "),
      ];
      if (this.activeBranchConfig.GENERAL.TKT_HN1 === "CERRADO") {
        this.switchMonToFri = false;
      } else {
        this.switchMonToFri = true;
        // console.log("this.activeBranchConfig.GENERAL.TKT_HN1");
        // console.log(this.activeBranchConfig.GENERAL.TKT_HN1);
        this.operatingHoursMonToFri =
          this.activeBranchConfig.GENERAL.TKT_HN1.split(" ");
        // console.log("this.operatingHoursMonToFri****");
        // console.log(this.operatingHoursMonToFri);
      }
      if (this.activeBranchConfig.GENERAL.TKT_HN2 === "CERRADO") {
        this.switchSaturday = false;
      } else {
        this.switchSaturday = true;
        this.operatingHoursSaturday =
          this.activeBranchConfig.GENERAL.TKT_HN2.split(" ");
      }
      if (this.activeBranchConfig.GENERAL.TKT_HN3 === "CERRADO") {
        this.switchSunday = false;
      } else {
        this.switchSunday = true;
        this.operatingHoursSunday =
          this.activeBranchConfig.GENERAL.TKT_HN3.split(" ");
      }
      this.$refs.integraciones.close();
      switch (section) {
        case "integraciones":
          const data = this.activeBranchConfig.INTEGRACIONES;
          this.$refs.integraciones.start(data);
          break;
        default:
          break;
      }
      this.show = section;
    },
    showInfoPopUp() {
      this.$swal.fire({
        title: "Recuerda!",
        text: "Los cambios que hagas no tendrán efecto hasta reiniciar el sistema en los equipos de recepción.",
        icon: "info",
        confirmButtonColor: "#6bd098",
      });
    },
    addCorreoCierresCaja() {
      if (this.correoCierresCaja.length < 5) {
        this.correoCierresCaja.push("");
      }
    },
    async fetchPOSConfigs() {
      this.$swal.fire({
        title: "Cargando...",
        text: "Esto puede tomar unos segundos",
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {},
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/fetch/POSconfigs",
              },
            }
          )
          .then((res) => {
            this.$swal.close();
            if (res.data.error) {
              this.$swal.fire({
                title: "Error :(",
                text: "Ha ocurrido un error al recuperar tus configuraciones, ponte en contacto con soporte.",
                icon: error,
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
            } else {
              let count = 0;
              let unconfiguredBranches = [];
              res.data.result.forEach((branchCfg) => {
                this.branchesConfigs[branchCfg.sucursal] = { ...branchCfg };
              });
              Object.keys(this.branchesConfigs).forEach((key) => {
                if (this.branchesConfigs[key].sucursal) {
                  // console.log(this.branchesConfigs[key]);
                } else {
                  const branchData = _.filter(this.branches, { _id: key });
                  count++;
                  unconfiguredBranches.push(branchData[0].nombreSucursal);
                  this.branchesConfigs[key] = {
                    ...this.configDefault,
                    sucursal: key,
                    nombreSucursal: branchData[0].nombreSucursal,
                    new: true,
                  };
                }
              });
              if (count > 1) {
                this.$swal.fire({
                  title: `Tienes ${count} sucursales sin configurar`,
                  text: unconfiguredBranches.join(", ").toUpperCase(),
                  icon: "warning",
                  confirmButtonColor: "#6bd098",
                });
              } else if (count === 1) {
                this.$swal.fire({
                  title: `Tienes ${count} sucursal sin configurar`,
                  text: unconfiguredBranches[0],
                  icon: "warning",
                  confirmButtonColor: "#6bd098",
                });
              }
            }
          });
      } catch (ex) {
        // console.log(ex);
        this.$swal.fire({
          title: "Error :(",
          text:
            ex.message ||
            "Ha ocurrido un error al recuperar tus configuraciones, ponte en contacto con soporte.",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        });
      }
    },
    async fetchPOSConfigsDictionaries() {
      try {
        await this.$MasterControlAPP
          .post(
            "",
            {
              Parameters: {},
            },
            {
              headers: {
                "Content-Type": "application/json",
                token: sessionStorage.getItem("jCxbraoQeD"),
                operation: "/v1/fetch/PoSconfigs/dictionary",
              },
            }
          )
          .then((res) => {
            this.$swal.close();
            if (res.data.error) {
              this.$swal.fire({
                title: "Error :(",
                text: "Ha ocurrido un error al recuperar tus configuraciones, ponte en contacto con soporte.",
                icon: error,
                showConfirmButton: true,
                confirmButtonColor: "#6bd098",
              });
            } else {
              // console.log(res.data.result);
              this.TRXTypeDictionary = res.data.result.TRXType;
              this.$swal.close();
            }
          });
      } catch (ex) {
        // console.log(ex);
        this.$swal.fire({
          title: "Error :(",
          text:
            ex.message ||
            "Ha ocurrido un error al recuperar tus configuraciones, ponte en contacto con soporte.",
          icon: "error",
          showConfirmButton: true,
          confirmButtonColor: "#6bd098",
        });
      }
    },
    async fetchPOSConfigsV2() {
      let count = 0;
      let unconfiguredBranches = [];
      for (const branch of this.branches) {
        try {
          const res = await this.$MasterControlAPI.post(
            "",
            {
              Header: {
                Operacion: "/v1/fetch/PoS/config",
              },
              Auth: {
                Token: sessionStorage.getItem("jCxbraoQeD"),
              },
              Parameters: {
                sucursal: branch._id,
                nombreSucursal: branch.nombreSucursal,
              },
              Body: {},
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (
            res.data &&
            res.data.Response &&
            res.data.Response.DataOut === "NO MATCH"
          ) {
            count++;
            unconfiguredBranches.push(branch.nombreSucursal);
            this.branchesConfigs[branch._id] = {
              ...this.configDefault,
              sucursal: branch._id,
              nombreSucursal: branch.nombreSucursal,
              new: true,
            };
          } else if (
            res.data &&
            res.data.Response &&
            res.data.Response.DataOut
          ) {
            // console.log(`Config: ${branch.nombreSucursal}`);
            // console.log(res.data.Response.DataOut);
            this.branchesConfigs[branch._id] = res.data.Response.DataOut;
          } else {
            count++;
            unconfiguredBranches.push(branch.nombreSucursal);
            this.branchesConfigs[branch._id] = {
              ...this.configDefault,
              sucursal: branch._id,
              nombreSucursal: branch.nombreSucursal,
              new: true,
            };
            // console.log(`Sin config: ${branch.nombreSucursal}`);
          }
        } catch (ex) {
          console.error(
            `Error fetching config for branch: ${branch.nombreSucursal}`,
            ex
          );
          let errString;
          if (
            ex.response &&
            ex.response.data &&
            ex.response.data.Response &&
            ex.response.data.Response.Resultado
          ) {
            errString =
              ex.response.data.Response.Resultado.MensajeServicio || ex.message;
          } else {
            errString = ex.message;
          }
          this.$swal.fire({
            title: "Error :(!",
            text:
              errString ||
              "Ha ocurrido un error inesperado, ponte en contacto con soporte",
            icon: "error",
            confirmButtonColor: "#6bd098",
          });
        }
      }
      console.log("Todas las configuraciones se han cargado.");
      if (count > 1) {
        this.$swal.fire({
          title: `Tienes ${count} sucursales sin configurar`,
          text: unconfiguredBranches.join(", ").toUpperCase(),
          icon: "warning",
          confirmButtonColor: "#6bd098",
        });
      } else if (count === 1) {
        this.$swal.fire({
          title: `Tienes ${count} sucursal sin configurar`,
          text: unconfiguredBranches[0],
          icon: "warning",
          confirmButtonColor: "#6bd098",
        });
      } else {
        this.$swal.close(); // Cerrar el mensaje de carga
      }
    },
  },
  beforeMount() {
    this.branches = JSON.parse(sessionStorage.getItem("xxxwypt5ip"));
    this.accountType = sessionStorage.getItem("account-type");
    this.branches.forEach((branch) => {
      this.branchesConfigs[branch._id] = {};
    });
  },
  mounted() {
    this.$swal.fire({
      title: "Cargando...",
      text: "Esto puede tomar unos segundos",
      allowOutsideClick: false,
      didOpen: () => {
        this.$swal.showLoading();
      },
    });
    Promise.all([
      this.fetchPOSConfigsV2(),
      this.fetchPOSConfigsDictionaries(),
    ]).then((res) => {
      // this.$swal.close();
    });
  },
};
</script>

<style></style>
